import { ImageLoaderConfig } from "@angular/common";
import { environment } from "src/environments/environment";

const myCustomLoader = (config: ImageLoaderConfig) => {
  if (!config.src) {
    return '';
  }

  return config.src + "?width=" + (config.width || 1080);
};

export {myCustomLoader};